module.exports = __webpack_public_path__ + "91bbb7036ea0ff1f636dd6ad83b8138c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-768.webp.png
// module id = 478
// module chunks = 0